// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserInfoAPI, updateUserInfoAPI } from "./authAPI";
import { authService } from "../../services/authService";

const initialState = {
  isLoggedIn: false,
  // 사용자 정보를 한 번이라도 받아봤는지. 관리자 메뉴처럼 사용자에 따라 갈리는
  // 판단은 이 값이 true 가 된 뒤에 해야 한다. 받기 전에는 누구인지 모른다.
  isUserLoaded: false,
  user: {
    id: 0,
    session: "",
    max_student_capacity: 0,
    // 정원을 넘겨 숨겨진 학생 수. 0 보다 크면 첫 화면에 인원 초과 안내가 뜬다.
    hidden_student_count: 0,
    plan: "",
  },
};

export const fetchUserInfo = createAsyncThunk(
  "auth/fetchUserInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchUserInfoAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUserInfo = createAsyncThunk(
  "auth/updateUserInfo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateUserInfoAPI(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state) {
      state.isLoggedIn = true;
    },
    loginFailure(state) {
      state.isLoggedIn = false;
    },
    logOut(state) {
      state.isLoggedIn = false;
      authService.removeTokens();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isUserLoaded = true;
    });
    builder.addCase(fetchUserInfo.rejected, (state) => {
      state.isLoggedIn = false;
      // 실패도 '더 기다려도 소용없다' 는 결론이라 판단을 막지 않는다.
      state.isUserLoaded = true;
    });
    builder.addCase(updateUserInfo.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isUserLoaded = true;
    });
    builder.addCase(updateUserInfo.rejected, (state) => {
      state.isLoggedIn = false;
    });
  },
});

export const { loginSuccess, loginFailure, logOut } = authSlice.actions;
export default authSlice.reducer;
